import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
}));

const PanelTitle = ({ children, button, id }) => {
  const classes = useStyle();

  return (
    <div className={classes.root} id={id}>
      <Typography variant="h6">{children}</Typography>
      {button}
    </div>
  );
};

PanelTitle.defaultProps = {
  children: null,
  button: null,
  id: undefined,
};

PanelTitle.propTypes = {
  children: PropTypes.node,
  button: PropTypes.node,
  id: PropTypes.string,
};

export default PanelTitle;
